import styles from "./ItemComment.module.css";
import { TextField } from "@mui/material";

// react
import { useState, useEffect } from "react";
import { useForm } from "hooks/useForm";
import Foco from "react-foco";
import { useContext } from "react";

// context
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

// tools
import Services from "tools/Services";
import { beautifyDate, daysAgo } from "tools/dateHandlers";

//components
import ConfirmDialog from "components/ConfirmDialog";

export default function Comment(props) {
	const [{ commentEdit }, handleChange] = useForm({ commentEdit: props.comment.comment });
	const [editing, setEditing] = useState(false);
	const { role } = useContext(MyContext);
	const [userName, setUserName] = useState("");
	const [openDialog, setOpendialog] = useState(false);

	useEffect(() => {
		getNameCreator();
	});

	// handles
	// we pass the id of the comment to delete in parent component
	const handleClickDelete = (reason) => {
		if (reason == "yes") {
			props.onDelete(props.comment.idComment);
		}
		setOpendialog(false);
	};

	//Editng start and finish handles
	const handleEditingStart = () => {
		setEditing(true);
	};
	const handleEditingFinish = (e) => {
		if (e.key === "Enter") {
			setEditing(false);
			//updated in the parent component
			props.onEdit({ ...props.comment, comment: commentEdit });
		}
	};
	const handleEditingFinishOutside = () => {
		setEditing(false);
		props.onEdit({ ...props.comment, comment: commentEdit });
	};

	const getNameCreator = async () => {
		// GET
		let res = await Services.get("/User/getUser/" + props.comment.idCreator);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		setUserName(res.data.userName);
	};

	return (
		<div className={styles.container}>
			<div className={styles.autor}>
				{ role === Role.Admin && props.comment.username}
				{props.comment.intern && <div className={styles.intern}>Intern</div>}
			</div>

			{!editing && <div>{props.comment.comment}</div>}
			{editing && (
				<Foco onClickOutside={handleEditingFinishOutside}>
					<TextField
						multiline
						className={styles.input}
						type="text"
						name="commentEdit"
						value={commentEdit}
						onChange={handleChange}
						onKeyDown={handleEditingFinish}
					/>
				</Foco>
			)}
			<div className={styles.dateWraper}>
				<div className={styles.date}>{beautifyDate(props.comment.created)}</div>
				<div>{daysAgo(props.comment.created)}</div>
				{role === Role.Admin && (
					<>
						<ConfirmDialog open={openDialog} title={"Attention"} yes no onClose={handleClickDelete}>
							{"Are you sure you want to delete this comment?"}
						</ConfirmDialog>

						<button className={styles.button} onClick={handleEditingStart}>
							Edit
						</button>
						{/* <button className={styles.button} onClick={handleClickDelete}> */}
						<button className={styles.button} onClick={() => setOpendialog(true)}>
							Delete
						</button>
					</>
				)}
			</div>
		</div>
	);
}
